import { get } from '@client/lib/request';
import { CampaignForHeader } from '@client/redux/modules/headerCampaigns/types';

export function getHeaderCampaigns(): Promise<CampaignForHeader[]> {
    return get('/mylounge-api/header-campaigns').then(res =>
        Object.values(res)
    );
}
